/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UpdateIncidentDTO } from '../models/UpdateIncidentDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WazeIncidentsProxyControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public updateIncident(
        id: string,
        requestBody: UpdateIncidentDTO,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/proxy/waze/incidents/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public unlockIncident(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/proxy/waze/incidents/{id}/unlock',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public lockIncident(
        id: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/proxy/waze/incidents/{id}/lock',
            path: {
                'id': id,
            },
        });
    }
}
